.header,
.header_titlebar,
.header_float,
.buttonNewChat,
.buttonSend,
.input,
.welcome {
	/* CSS Modules theming placeholders */
}

.root {
	--transition-style: .3s ease;
	--color-transition: color var(--transition-style),
		background-color var(--transition-style);

	height: 100%;
}

.root a,
.root button {
	transition: var(--color-transition);
}

.root :global(.mantine-ActionIcon-icon) {
	width: 1.5em;
	height: 1.5em;
}

.root small {
	color: var(--mantine-color-dimmed);
}


.view {
	flex: 2;
}

.footer {
	border-width: 0;
	border-top-color: var(--mantine-primary-color-6);
	border-top-width: 3px;
}

.buttonSend:disabled {
	cursor: progress;
}

.promptSuggestion {
	cursor: pointer;
	transition: var(--color-transition);
	color: var(--mantine-color-gray-5);
	font-style: italic;
	font-weight: 500;
	padding: var(--mantine-spacing-xs);
}

.promptSuggestion:hover,
.promptSuggestion:focus {
	color: var(--mantine-color-gray-6);
}
